module.exports = __webpack_public_path__ + "static/img/Gacha07.7b03ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha07.png
// module id = klYa
// module chunks = 1